/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDName } from './IDName';
import {
    IDNameFromJSON,
    IDNameFromJSONTyped,
    IDNameToJSON,
    IDNameToJSONTyped,
} from './IDName';
import type { OrderProduct } from './OrderProduct';
import {
    OrderProductFromJSON,
    OrderProductFromJSONTyped,
    OrderProductToJSON,
    OrderProductToJSONTyped,
} from './OrderProduct';
import type { Branch } from './Branch';
import {
    BranchFromJSON,
    BranchFromJSONTyped,
    BranchToJSON,
    BranchToJSONTyped,
} from './Branch';
import type { OrderPayment } from './OrderPayment';
import {
    OrderPaymentFromJSON,
    OrderPaymentFromJSONTyped,
    OrderPaymentToJSON,
    OrderPaymentToJSONTyped,
} from './OrderPayment';

/**
 * 
 * @export
 * @interface ExtendedOrder
 */
export interface ExtendedOrder {
    /**
     * 
     * @type {string}
     * @memberof ExtendedOrder
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedOrder
     */
    reference?: number;
    /**
     * 
     * @type {Branch}
     * @memberof ExtendedOrder
     */
    branch: Branch;
    /**
     * 
     * @type {number}
     * @memberof ExtendedOrder
     */
    net_sales: number;
    /**
     * 
     * @type {number}
     * @memberof ExtendedOrder
     */
    gross_sales: number;
    /**
     * 
     * @type {number}
     * @memberof ExtendedOrder
     */
    taxes: number;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedOrder
     */
    business_date: Date;
    /**
     * 
     * @type {IDName}
     * @memberof ExtendedOrder
     */
    order_type: IDName;
    /**
     * 
     * @type {IDName}
     * @memberof ExtendedOrder
     */
    order_source: IDName;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedOrder
     */
    opened_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedOrder
     */
    closed_at: Date;
    /**
     * 
     * @type {number}
     * @memberof ExtendedOrder
     */
    guests: number;
    /**
     * 
     * @type {Array<OrderPayment>}
     * @memberof ExtendedOrder
     */
    payments: Array<OrderPayment>;
    /**
     * 
     * @type {Array<OrderProduct>}
     * @memberof ExtendedOrder
     */
    products: Array<OrderProduct>;
    /**
     * 
     * @type {Array<IDName>}
     * @memberof ExtendedOrder
     */
    order_tags: Array<IDName>;
}

/**
 * Check if a given object implements the ExtendedOrder interface.
 */
export function instanceOfExtendedOrder(value: object): value is ExtendedOrder {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('branch' in value) || value['branch'] === undefined) return false;
    if (!('net_sales' in value) || value['net_sales'] === undefined) return false;
    if (!('gross_sales' in value) || value['gross_sales'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('business_date' in value) || value['business_date'] === undefined) return false;
    if (!('order_type' in value) || value['order_type'] === undefined) return false;
    if (!('order_source' in value) || value['order_source'] === undefined) return false;
    if (!('opened_at' in value) || value['opened_at'] === undefined) return false;
    if (!('closed_at' in value) || value['closed_at'] === undefined) return false;
    if (!('guests' in value) || value['guests'] === undefined) return false;
    if (!('payments' in value) || value['payments'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('order_tags' in value) || value['order_tags'] === undefined) return false;
    return true;
}

export function ExtendedOrderFromJSON(json: any): ExtendedOrder {
    return ExtendedOrderFromJSONTyped(json, false);
}

export function ExtendedOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendedOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reference': json['reference'] == null ? undefined : json['reference'],
        'branch': BranchFromJSON(json['branch']),
        'net_sales': json['net_sales'],
        'gross_sales': json['gross_sales'],
        'taxes': json['taxes'],
        'business_date': (new Date(json['business_date'])),
        'order_type': IDNameFromJSON(json['order_type']),
        'order_source': IDNameFromJSON(json['order_source']),
        'opened_at': (new Date(json['opened_at'])),
        'closed_at': (new Date(json['closed_at'])),
        'guests': json['guests'],
        'payments': ((json['payments'] as Array<any>).map(OrderPaymentFromJSON)),
        'products': ((json['products'] as Array<any>).map(OrderProductFromJSON)),
        'order_tags': ((json['order_tags'] as Array<any>).map(IDNameFromJSON)),
    };
}

export function ExtendedOrderToJSON(json: any): ExtendedOrder {
    return ExtendedOrderToJSONTyped(json, false);
}

export function ExtendedOrderToJSONTyped(value?: ExtendedOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reference': value['reference'],
        'branch': BranchToJSON(value['branch']),
        'net_sales': value['net_sales'],
        'gross_sales': value['gross_sales'],
        'taxes': value['taxes'],
        'business_date': ((value['business_date']).toISOString()),
        'order_type': IDNameToJSON(value['order_type']),
        'order_source': IDNameToJSON(value['order_source']),
        'opened_at': ((value['opened_at']).toISOString()),
        'closed_at': ((value['closed_at']).toISOString()),
        'guests': value['guests'],
        'payments': ((value['payments'] as Array<any>).map(OrderPaymentToJSON)),
        'products': ((value['products'] as Array<any>).map(OrderProductToJSON)),
        'order_tags': ((value['order_tags'] as Array<any>).map(IDNameToJSON)),
    };
}

